export default "__VITE_ASSET__BGiRd65U__"